<template>
<section class="section searchResults speciesTable" :class="{'extra-column': hasWetlandColumn || hasOSRColumn}">
  <div class="container">
    <div class="bodySearchResults">
      <div class="resultHeader">

          <div class="photo is-hidden-mobile">
          </div>
          <!-- this can be write as a loop -->
          <template v-for="(col, index) in Object.keys(header)" :key="'table' + index">
            <div :class="[header[col]]" class="clickable">
              <p class="caps clickable" @click="sortColumn(index)">
                <strong>{{ $t("search.columns." + col) }}</strong>
                <svg v-if="state.order[0]?.column === index" :class="orderArrowStyle">
                  <use xlink:href="@/assets/sprite.svg#icon-chevron"></use>
                </svg>
                <svg class="sortable" v-else>
                  <use xlink:href="@/assets/sprite.svg#icon-sortable"></use>
                </svg>
              </p>
            </div>
          </template>
      </div>
      <div class="sppTableResult resultList">
        <div v-for="(item, $index) in state.list" :key="$index" class="singleResult" @click="openProfile(item)">
          <div class="photo is-hidden-mobile">
            <img :src="profileImageUrlPrefix + item.scientificName" alt="placeholder" class="rounded-1">
          </div>
          <div class="common">
            {{ item.commonName }}
          </div>
          <div class="scientific">
            <em>{{ item.scientificName }}</em>
          </div>
          <div class="categories is-hidden-mobile">
            <a v-tooltip.left="{ html: true, content: $t('search.tooltips.' + item.summaryType)}"
            class="tag" :class="{c8: item.summaryType === 'Full', c1: item.summaryType === 'Forested', c3: item.summaryType === 'Prairie', c4: item.summaryType === 'Basic'}">{{item.summaryType}}</a>
          </div>
          <div :class="[header.wetland]" v-if="hasWetlandColumn">
            <a v-tooltip.left="{ html: true, content: $t('search.wetland.description')}" class="c6" v-if="item.hasWetland == 1">{{ $t("search.columns.wetland") }}</a>
          </div>
          <div :class="[header.osr]" v-if="hasOSRColumn">
            <a v-if="item.hasOSR == 1" v-tooltip.left="{ html: true, content: $t('search.tooltips.OSR')}" class="tag" :class="{c9: item.hasOSR === 1}">{{ $t("search.columns.osr") }}</a>
          </div>
          <div :class="[header.cmsProfile]" v-if="hasCMSProfileColumn">
            <a  v-if="item.hasCMSProfile == 1" v-tooltip.left="{ html: true, content: $t('search.tooltips.CMSProfile')}" class="hasprofile" :class="{c9: item.hasCMSProfile === 'Y'}">
              <svg class="hasprofile">
                <use xlink:href="@/assets/sprite.svg#icon-has-profile">
                </use>
              </svg>
            </a>
          </div>
        </div>
        <!-- issue with inifinitely loading no-result slot
        when all results fit  in one api, it is shown by error, so this is a work around
        -->
        <div class="noResult" v-show="state.filteredRecordNo === 0 && isTableLoaded">{{ $t("common.load.noResult") }}</div>
        <div v-show="!isTableLoaded">
          <SpinningIcon />
        </div>
        <infinite-loading  ref="childLoadingRef"
          :distance="100"
          bottom
          :identifier="tableRedrawIdentifier"
          target=".sppTableResult"
          @infinite="infiniteHandler">
          <template #no-result>{{ $t("common.load.noResult") }}</template>
          <template #complete><span/></template>
          <template #spinner>
            <SpinningIcon />
          </template>
          </infinite-loading>
      </div>
    </div>
  </div>
</section>

</template>

<script setup>
/* this component hanldes the species table
*/
import { computed } from 'vue';
import { sppSearchState } from '@/composables/state/speciesSearchApp';
import { getGroupNameById } from '@/config/spp-list-config.js';
import { getProfileUrl } from '@/config/profile-config.js';
import InfiniteLoading from 'v3-infinite-loading';
import 'v3-infinite-loading/lib/style.css';
import SpinningIcon from '@/components/map/SpinningIcon.vue';

const {
  state,
  infiniteHandler, // https://vue3-infinite-loading-demo.netlify.app/
  sortColumn,
  childLoadingRef,
  hasWetlandColumn,
  hasOSRColumn,
  hasCMSProfileColumn,
  tableRedrawIdentifier,
  isTableLoaded,
} = sppSearchState();
const profileImageUrlPrefix = import.meta.env.VITE_APP_PHOTO_PROFILE_URL_PREFIX;

const openProfile = (item) => {
  const url = getProfileUrl(item, getGroupNameById(state?.groupId)); // profileUrl + getSpeciesNameByGroup(item, state.groupName) + (item.year ? '&year=' + item.year : '');
  window.location.href = url;
};

const orderArrowStyle = computed(() => {
  return { arrowDown: state.order[0]?.dir === 'asc', arrowUp: state.order[0]?.dir === 'desc' };
});

const header = {
  cname: 'common',
  sname: 'scientific',
  summary: 'categories is-hidden-mobile',
  wetland: 'tags-header is-hidden-mobile',
  osr: 'tags-header categories is-hidden-mobile',
  cmsProfile: 'categories is-hidden-mobile'
};
if (!hasOSRColumn) {
  delete header.osr
}
if (!hasWetlandColumn) {
  delete header.wetland
}
if (!hasCMSProfileColumn) {
  delete header.cmsProfile
}
</script>

<style scoped>
  .speciesTable.extra-column .bodySearchResults .common,
  .speciesTable.extra-column .bodySearchResults .scientific {
    text-align: center;
    width: 30%;
  }

  .speciesTable.extra-column .bodySearchResults .categories {
    text-align: center;
    width: 30%;
  }

  .categories a.tag {
    margin: 0 1em;
  }
  .speciesTable.extra-column .tags-header {
    text-align: center;
    padding: 0 14px;
    width: 30%;
    height: 100%;
  }

  .speciesTable.extra-column .tags-header p {
    padding: 4px 0;
    margin: 0;
  }

  .clickable {
    cursor: pointer;
  }
  .bodySearchResults .resultHeader .tags-header a, .bodySearchResults .singleResult .tags-header a {
      background-color: #185a86;
      display: inline-block;
      padding: 2px 8px;
      margin: 0 2px;
      color: #fff;
      border-radius: 30px;
      font-size: .75em;
      letter-spacing: .02em;
      line-height: normal;
  }
  .singleResult:hover {
    cursor: pointer;
    background-color: #e2e2e2;
  }
  .noResult {
    margin:50px;
    text-align: center;
    margin: 50px;
    font-size: 1.2em;
    color: rgb(255, 152, 0);
  }
  .bodySearchResults p svg {
    margin-left: 10px;
  }
  div#filterExpand {
    margin-top: -30px;
  }
  .filterList {
    margin-top: -10px;
  }
  .section.speciesTable {
    padding: 0.5rem 1.5rem 1.5rem 1.5rem;
    margin-bottom: 1.5rem;
  }
  /* for fixing scroll bar width change*/
  .resultHeader {
    width: calc(100% - 15px);
  }
  .resultList {
    scrollbar-gutter: stable;
    height: 640px;
    overflow-y: auto;
    margin-bottom: 2rem;
  }
  .sortable {
    stroke: #666;
    fill: #666;
    width: 18px;
    height: 18px;
  }
  svg.hasprofile {
    stroke: #022203;
    fill: none;
    width: 24px;
    height: 24px;
  }
</style>
